import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungBonn() {
  return (
    <CityPageTemplate
      city="Bonn"
      slug="bonn"
      intro="Die ehemalige Bundeshauptstadt Bonn – wir bringen Deine Finanzen auf Regierungsniveau."
      description="Unabhängige Finanzberatung für Bonn – 100% digital, kostenlose Erstberatung. Altersvorsorge, ETF, Steueroptimierung & staatliche Förderungen."
    />
  );
}
